// ค่ากลางของหน้าภาษีบริษัท ใช้ร่วมกันทั้งปฏิทินภาษี พยากรณ์ และภาษีนิติบุคคล

export const MONTHLY_FORMS = ["pgd1", "pgd3", "pgd53", "pp30", "sso"];

export const STATUS_META = {
  pending: { label: "ยังไม่ยื่น", color: "#b97007", background: "rgba(245, 166, 35, 0.16)" },
  filed: { label: "ยื่นแล้ว", color: "#0b4f84", background: "rgba(12, 118, 229, 0.12)" },
  paid: { label: "จ่ายแล้ว", color: "#188251", background: "rgba(47, 181, 114, 0.14)" },
};

export const OVERDUE_META = { label: "เกินกำหนด", color: "#b63636", background: "rgba(229, 83, 83, 0.14)" };

export const cardStyle = {
  background: "linear-gradient(180deg, #ffffff 0%, #f2f9ff 100%)",
  border: "1px solid rgba(18, 125, 255, 0.10)",
  boxShadow: "0 14px 28px rgba(12, 118, 229, 0.06)",
};

export const blockStyle = {
  background: "#ffffff",
  border: "1px solid rgba(18, 125, 255, 0.10)",
  borderRadius: 20,
  boxShadow: "0 10px 24px rgba(12, 118, 229, 0.05)",
};

export const toThaiYear = (year) => Number(year || 0) + 543;

export const monthShort = (periodMonth) => {
  const months = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
  const index = Number(String(periodMonth || "").slice(5, 7)) - 1;
  return months[index] || periodMonth;
};

// สีสถานะของช่องในปฏิทินภาษี เกินกำหนดสำคัญกว่าสถานะปกติ
export const cellMeta = (cell) => {
  if (!cell) return STATUS_META.pending;
  if (cell.overdue) return OVERDUE_META;
  return STATUS_META[cell.status] || STATUS_META.pending;
};
